import { TicketStatusEnum } from '@gid/models';

/**
 * UI metadata per ticket status: a bootstrap badge variant + an i18n label key.
 * Keyed by the spelled-out enum value that the GID DB stores (init/new/…).
 */
export const TICKET_STATUS_META = {
  [TicketStatusEnum.I]: { variant: 'light', labelKey: 'tickets.status.init' },
  [TicketStatusEnum.N]: { variant: 'primary', labelKey: 'tickets.status.new' },
  [TicketStatusEnum.T]: {
    variant: 'info',
    labelKey: 'tickets.status.chatting',
  },
  [TicketStatusEnum.P]: {
    variant: 'info',
    labelKey: 'tickets.status.calling',
  },
  [TicketStatusEnum.R]: {
    variant: 'secondary',
    labelKey: 'tickets.status.resolved',
  },
  [TicketStatusEnum.X]: {
    variant: 'dark',
    labelKey: 'tickets.status.deleted',
  },
  [TicketStatusEnum.B]: { variant: 'danger', labelKey: 'tickets.status.spam' },
  [TicketStatusEnum.A]: {
    variant: 'success',
    labelKey: 'tickets.status.answered',
  },
  [TicketStatusEnum.C]: { variant: 'info', labelKey: 'tickets.status.open' },
  [TicketStatusEnum.W]: {
    variant: 'warning',
    labelKey: 'tickets.status.postponed',
  },
  [TicketStatusEnum.L]: {
    variant: 'secondary',
    labelKey: 'tickets.status.closed',
  },
};

/**
 * Statuses offered in the filter multi-select and the action-bar dropdown, in a
 * triage-friendly order (actionable first, terminal last).
 */
export const SELECTABLE_TICKET_STATUSES = [
  TicketStatusEnum.N,
  TicketStatusEnum.C,
  TicketStatusEnum.A,
  TicketStatusEnum.W,
  TicketStatusEnum.T,
  TicketStatusEnum.P,
  TicketStatusEnum.R,
  TicketStatusEnum.L,
  TicketStatusEnum.B,
  TicketStatusEnum.I,
  TicketStatusEnum.X,
];

export function statusVariant(status) {
  return TICKET_STATUS_META[status]?.variant || 'secondary';
}

export function statusLabelKey(status) {
  return TICKET_STATUS_META[status]?.labelKey || 'tickets.status.unknown';
}
